import { Fragment } from 'react';
import { hyphenatableWordInput } from '@utils/component-framework';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { stateBox, word, char, readonlyHyphen } from './atom.facit.word.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function HyphenatableWordFacit(props) {
  const pageContext = usePageContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => hyphenatableWordInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const inputHyphenation = inputEntry?.hyphenation ?? [props.node.text];
  const boxState = props.facitContext === "should-have" && props.state === "incorrect" ? "should-have" : props.state;
  const segments = boxState === "should-have" ? props.node.validation.allowedHyphenations[0] : inputHyphenation;
  return /*#__PURE__*/jsx(StateBox, {
    state: boxState,
    className: stateBox,
    children: /*#__PURE__*/jsx("div", {
      className: word,
      "data-page-context": pageContext,
      children: segments?.map((segment, index) => /*#__PURE__*/jsxs(Fragment, {
        children: [[...segment].map((char$1, ci) => /*#__PURE__*/jsx("span", {
          className: char,
          children: char$1
        }, ci)), index !== segments.length - 1 && /*#__PURE__*/jsx("span", {
          className: readonlyHyphen,
          children: "-"
        })]
      }, index))
    })
  });
}

export { HyphenatableWordFacit };
//# sourceMappingURL=atom.facit.word.js.map
